import { BusEventWithPayload } from '@grafana/data';
import { getAppEvents } from '@grafana/runtime';

export interface K6SetScriptContentPayload {
  scriptContent: string;
}

/**
 * Event published by grafana-assistant-app to inject a script into the currently open k6 editor.
 * The k6 app subscribes to this event and updates the editor content in place,
 * avoiding a full page navigation.
 *
 * @example
 * ```typescript
 * import { onK6SetScriptContent } from '@grafana/assistant';
 *
 * const unsubscribe = onK6SetScriptContent(({ scriptContent }) => {
 *   editorRef.current?.setValue(scriptContent);
 * });
 *
 * // On unmount
 * unsubscribe();
 * ```
 */
export class K6SetScriptContentEvent extends BusEventWithPayload<K6SetScriptContentPayload> {
  static type = 'grafana-assistant:k6-set-script-content';
}

/**
 * Subscribe to k6 set-script-content events emitted by grafana-assistant-app.
 * Returns an unsubscribe function.
 */
export function onK6SetScriptContent(callback: (payload: K6SetScriptContentPayload) => void): () => void {
  const subscription = getAppEvents().subscribe(K6SetScriptContentEvent, (event) => {
    callback(event.payload);
  });
  return () => subscription.unsubscribe();
}
